module.exports = __webpack_public_path__ + "img/img-ddf323.png";